import React from 'react';

const Pagination = ({ 
  currentPage, 
  totalPages, 
  onPageChange,
  className = ""
}) => {
  if (totalPages <= 1) return null;

  return (
    <div className={`flex justify-end gap-2 mt-auto ${className}`}>
      <button
        onClick={() => onPageChange(currentPage - 1)}
        disabled={currentPage === 1}
        className="bg-blue-900 dark:bg-blue-700 text-white rounded-lg px-4 py-1 hover:bg-blue-700 dark:hover:bg-blue-800 transition-all shadow focus:ring-2 focus:ring-blue-400 disabled:opacity-50 disabled:cursor-not-allowed"
      >
        Назад
      </button>
      <span className="text-base text-gray-700 dark:text-gray-300 font-light flex items-center">
        Страница {currentPage} из {totalPages}
      </span>
      <button
        onClick={() => onPageChange(currentPage + 1)}
        disabled={currentPage === totalPages}
        className="bg-blue-900 dark:bg-blue-700 text-white rounded-lg px-4 py-1 hover:bg-blue-700 dark:hover:bg-blue-800 transition-all shadow focus:ring-2 focus:ring-blue-400 disabled:opacity-50 disabled:cursor-not-allowed"
      >
        Вперед
      </button>
    </div>
  );
};

export default Pagination;
